define("powergen/components/x-keyboard",
  [],
  function() {
    "use strict";
    var XKeyboardComponent;

    XKeyboardComponent = Ember.Component.extend({
      tagName: 'div',
      classNames: ['keyboard'],
      actions: {
        keyUp: function(key) {
          var newValue, oldValue;
          oldValue = this.get('inputValue');
          switch (key.get('id')) {
            case 'delete':
              newValue = oldValue.substr(0, oldValue.length - 1);
              break;
            case 'space':
              newValue = oldValue + ' ';
              break;
            case '.com':
              newValue = oldValue + '.com';
              break;
            default:
              newValue = oldValue + key.get('id');
          }
          return this.sendAction('inputValueChanged', {
            inputName: this.get('inputName'),
            inputValue: newValue
          });
        }
      }
    });


    return XKeyboardComponent;
  });